import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { fetchmeetingshortcode } from "../../redux/getShortCode/getmeetingtypeshortcode";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../Components/Common/Loader";
import { Form, Input } from 'antd';

const MeetingType = ({ setShowType }) => {
  //for errors


  const [NameEn, setNameEn] = useState("");
  const [NameAr, setNameAr] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const { data: meetingshortcode } = useSelector((state) => state.meetingshortcode)
  const dispatch = useDispatch();

  const history = useNavigate();
  const { pathname } = useLocation();

  const [state1, setState] = useState({
    shortCode: '',
  });

  useEffect(() => {
    if (meetingshortcode) {
      setState({
        shortCode: meetingshortcode.length === 0 ? 10 : meetingshortcode[0].maxshortCode + 1,
      });
    } else {
      setState.shortCode('9')
    }
  }, [meetingshortcode]);

  useEffect(() => {
    dispatch(fetchmeetingshortcode());
  }, [dispatch])


  const submit = async (event) => {
    setisLoading(true)
    try {
      const formData = new FormData();
      formData.append("NameEn", NameEn);
      formData.append("NameAr", NameAr);
      formData.append("shortCode", state1.shortCode);

      await axios.post(`${window.env.API_URL}/uploadMeetingType`, formData);
      swal({
        title: "Success!",
        text: "Data has been added Successfully ",
        icon: "success",
        button: "OK",
      });
      if (pathname === "/meeting") {
        history("/getmeeting");
      } setShowType(false)
      setisLoading(false)
    } catch (error) {
      const err = error.response.data.message[0];
      const err1 = error.response.data.message[1];
      const err2 = error.response.data.message[2];


      swal({
        title: "Error!",
        text: err, err1, err2,
        icon: "error",
        button: "OK",
      });
      setisLoading(false)
    }
  };





  return (
    <div className="page">
      <div className="rightsidedata">
        <div
          style={{
            marginTop: "30px",
          }}
        >
          <div className="Headers">Create Meeting Type</div>
          {isLoading ? <Loader /> : <div className="form">
            <Form onFinish={submit}
              fields={[{

                name: "shortCode",
                value: state1.shortCode

              }]}
            >
              <div className="row mainrow">
                <div className="col-sm">


                  <Form.Item
                    name="NameEn"
                    label="Title"
                    rules={[
                      {
                        required: true,
                        message: 'Title (English) is required',
                      },
                    ]}
                  >
                    <Input placeholder="Title" onChange={(e) => setNameEn(e.target.value)}
                      value={NameEn} name="NameEn" />
                  </Form.Item>



                  <span className="spanForm"> |</span>





                </div>

                <div className="col-sm">
                  <Form.Item
                    name="TitleAr"
                    label="عنوان"
                    rules={[
                      {
                        required: true,
                        message: 'Title (Arabic) is required',
                      },
                    ]}
                    style={{ direction: 'rtl' }}
                  >
                    <Input placeholder="عنوان" onChange={(e) => setNameAr(e.target.value)}
                      name="TitleAr"
                      value={NameAr} />
                  </Form.Item>

                </div>
              </div>
              <div className="row mainrow">
                <div className="col-sm">

                  <Form.Item
                    name="shortCode"
                    label="Short Code"
                    rules={[
                      {
                        required: true,
                        message: "short Code is required"
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) =>
                        setState({ ...state1, shortCode: e.target.value })
                      }
                      value={state1.shortCode}


                      onPaste={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Short Code"
                      maxLength="5"
                      name="shortCode"
                    />
                  </Form.Item>

                </div>
              </div>

              <div className="ButtonSection" style={{ justifyContent: "end" }}>
                <button
                  type="submit"
                  className="SubmitButton"
                  disabled={isLoading}
                >
                  Add Meeting
                </button>
              </div>
            </Form>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default MeetingType;